export default __webpack_public_path__ + "static/superfuzz-f0bf31c0c405d8afe9fabf41f8f95c51.png";